// extracted by mini-css-extract-plugin
module.exports = {"footNav":"footNav-module--footNav--1xVT_","logo":"footNav-module--logo--38WoJ","nav":"footNav-module--nav--2e28u","icons":"footNav-module--icons--29qz7"};